import { render } from "./device-create.vue?vue&type=template&id=2cd9e4f1&scoped=true"
import script from "./device-create.vue?vue&type=script&lang=js"
export * from "./device-create.vue?vue&type=script&lang=js"

import "./device-create.vue?vue&type=style&index=0&id=2cd9e4f1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd9e4f1"]])

export default __exports__